import type { JSX } from 'react';

import Emphasis from 'DesignSystem3/Text/Emphasis';

import AnimatedOdds from './AnimatedOdds';

interface OddsAndChangeProps {
    odds: number;
    change: number;
    size: string;
    showChange?: boolean;
    textColor?: string;
}

const OddsAndChange = ({ odds, change, size, showChange = true, textColor }: OddsAndChangeProps): JSX.Element => {
    const GetOddsComponent = (size: string) => {
        switch (size) {
            case 'large':
                return Emphasis.x40;
            case 'small':
                return Emphasis.x20;
            case 'tiny':
                return Emphasis.x10;
            default:
                return Emphasis.x40; // Default to large if no size is provided
        }
    };

    const EmphasisComponent = GetOddsComponent(size);

    return (
        <div className={`flex items-center ` + (size === 'large' ? 'gap-1' : 'gap-[2px]')}>
            <div className="flex items-center leading-none">
                <EmphasisComponent style={textColor ? { color: textColor } : undefined}>
                    <AnimatedOdds odds={odds} change={change} />
                </EmphasisComponent>
            </div>
            {change !== 0 && (
                <>
                    <div className={'flex gap-[2px] ' + (change > 0 ? 'text-green-x10' : 'text-red-x10')}>
                        <Emphasis.x10 style={textColor ? { color: textColor } : undefined}>
                            {change > 0 ? '▲' : '▼'}
                        </Emphasis.x10>
                        {showChange ? (
                            <Emphasis.x10 style={textColor ? { color: textColor } : undefined}>
                                {Math.abs(change)}
                            </Emphasis.x10>
                        ) : (
                            <></>
                        )}
                    </div>
                </>
            )}
        </div>
    );
};

export default OddsAndChange;
